module.exports = __webpack_public_path__ + "img/arrow-circle-left.e17b7e35.svg";